import UserModel from 'src/models/UserModel';
import { createTokenStore } from './tokenStore';

/**
 * Exchanged straight against is-payments, mirroring what the Next.js app already does
 * (`nextjs/app/services/is-payments/request-token-from-is-payments.ts`), so the same issuer signs
 * the token that `/api/v1/accounts/me/*` verifies.
 *
 * Not to be confused with `paymentsToken.ts`, which exchanges against the payments *landing page*
 * and only feeds the redirect-to-landing-page flow.
 */
const { getToken, clearToken } = createTokenStore({
  getExchangeUrl: () => `${process.env.REACT_APP_IS_PAYMENTS}/auth/exchange-token`,
  getParseToken: () => UserModel.getInstance().sessionToken
});

export const getIsPaymentsToken = getToken;
export const clearIsPaymentsToken = clearToken;
